import React from 'react';

export default function ColumnConfig({ sectionKey, allColumns, activeColumns, onChange }) {
  const toggle = (colKey) => {
    if (activeColumns.includes(colKey)) {
      onChange(activeColumns.filter((c) => c !== colKey));
    } else {
      const ordered = allColumns
        .map((c) => c.key)
        .filter((k) => activeColumns.includes(k) || k === colKey);
      onChange(ordered);
    }
  };

  return (
    <div className="column-config">
      <h3>Columns for: {sectionKey}</h3>
      <div className="column-list">
        {allColumns.map((col) => (
          <button
            key={col.key}
            className={`column-chip${activeColumns.includes(col.key) ? ' active' : ''}`}
            onClick={() => toggle(col.key)}
          >
            {activeColumns.includes(col.key) ? '✓' : '○'} {col.label}
          </button>
        ))}
      </div>
    </div>
  );
}
